<ng-container>
    <button mat-mini-fab aria-label="Today" (click)="navigateToToday()">
        <mat-icon svgIcon="mat_outline:today"></mat-icon>
    </button>
    <button mat-mini-fab aria-label="Previous" (click)="navigateToPrevious()">
        <mat-icon svgIcon="mat_outline:chevron_left"></mat-icon>
    </button>
    <button mat-mini-fab aria-label="Next" (click)="navigateToNext()">
        <mat-icon svgIcon="mat_outline:chevron_right"></mat-icon>
    </button>
</ng-container>
